export enum EAircraftEventType {
  Maintenance = 'Maintenance',
  Trip = 'Trip',
  NoCrew = 'NoCrew',
  TripLeg = 'TripLeg',
}
